import { Empty as AntdEmpty } from "@mijadesign/web";
import type { ComponentProps } from "react";

type AntdEmptyProps = ComponentProps<typeof AntdEmpty>;

interface EmptyWrapperProps extends AntdEmptyProps {
  visible?: boolean;
}

function EmptyWrapper({ visible = true, ...props }: EmptyWrapperProps) {
  if (!visible) {
    return null;
  }
  return <AntdEmpty {...props} />;
}

export default EmptyWrapper;
